<script>
import Loader from "./loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
  data() {
    return {
      TableData: {},
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      AcikAnketSayisi: 0,
      KapaliAnketSayisi: 0,
    };
  },
  components: {
    Loader,
  },
  props: {
    updating: {
      type: Boolean,
    },
  },
  methods: {
    Get() {
      let Data = {
        Filter: "SELECT COUNT(id) as AnketSayisi FROM anktanket WHERE anketkapalimi = false",
      };
      this.ActionsPost({ Service: "AnktAnketCevap/Raporlama", Data: Data }).then((res) => {
        if (res) {
          this.AcikAnketSayisi = res;
        }
      });

      Data = {
        Filter: "SELECT COUNT(id) as AnketSayisi FROM anktanket WHERE anketkapalimi = true",
      };
      this.ActionsPost({ Service: "AnktAnketCevap/Raporlama", Data: Data }).then((res) => {
        if (res) {
          this.KapaliAnketSayisi = res;
        }
      });
    },
  },
};
</script>
<template>
  <Loader :loading="updating">
      <div class="row">
        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">{{ this.$t("StrWidgets.AcikKapaliAnket.AcikAnket") }}</p>
                  <h5 class="mb-0">{{ AcikAnketSayisi }}</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                    <i class="bx bx-pie-chart-alt"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2"> {{ this.$t("StrWidgets.AcikKapaliAnket.KapaliAnket") }}</p>
                  <h5 class="mb-0">{{ KapaliAnketSayisi }}</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                    <i class="bx bx-bar-chart-alt-2"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">{{ this.$t("StrWidgets.AcikKapaliAnket.TopamAnket") }}</p>
                  <h5 class="mb-0">{{ AcikAnketSayisi + KapaliAnketSayisi }}</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                    <i class="bx bx-box"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </Loader>
</template>
